import { atom } from 'infrastructure/state/jotai.wrapper'
import { summaryDataByMasterIdAtom } from '../../components/tree/summaries/atoms'
import { byStringFieldSort } from '../../components/Helpers'

export const currentSelectedMasterAtom = atom('')
export const masterDetailsListAtom = atom<string[]>([])

export const sortedMastersAtom = atom(async (get) => {
  const mappedMasters = await get(summaryDataByMasterIdAtom)
  return Object.values(mappedMasters).sort(byStringFieldSort('curriculumTitle'))
})
